import React from "react";
import "./Hero.css";
import HeroMain from '../../../../assets/img/hero/hero-main.png'
import {Link} from 'react-router-dom';

const Hero = () => {
  return (
    <main className='main'>
      <section className="hero" id='hero'>
        <div className="hero__grid container">
          <img src={HeroMain} className='hero-img' alt='hero-main'/>
          <div className="hero__content">
            <h1 className="section-title">
              Apply for an Online Gaming License today.
              B2C or B2B
            </h1>
            <p className="hero-description">
              Being licensed and regulated by a reputable gaming board builds and instills confidence in your brand.
            </p>
            <Link to='/contact-us' className="btn">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Hero;
